export default "__VITE_ASSET__219e78d9__"